export const GENERIC_LOOKUP = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Yes'
}, {
	code: '2',
	value: 'No'
}]

export const SCHOOL_TYPE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Public'
}, {
	code: '2',
	value: 'Private'
}]

export const CIVIL_STATUS = [{
	code: '1',
	value: 'Single'
}, {
	code: '2',
	value: 'Married'
}, {
	code: '3',
	value: 'Widow / Widower'
}, {
	code: '4',
	value: 'Separated'
}, {
	code: '5',
	value: 'Common-law wife/husband live-in'
}, {
	code: '6',
	value: 'Unknown'
}]

export const RESIDENCY_OWNERSHIP = [{
	code: '1',
	value: 'Rent'
}, {
	code: '2',
	value: 'Owned'
}, {
	code: '3',
	value: 'Unknown / Informal Settler'
}]

export const RELATION_IN_HEAD = [{
	code: '1',
	value: 'Head'
}, {
	code: '2',
	value: 'Spouse'
}, {
	code: '3',
	value: 'Son / Daughter'
}, {
	code: '4',
	value: 'Son-in-law / Daughter-in-law'
}, {
	code: '5',
	value: 'Grandson / Granddaughter'
}, {
	code: '6',
	value: 'Father / Mother'
}, {
	code: '7',
	value: 'Other relatives'
}, {
	code: '8',
	value: 'Housemaid / Houseboy / Helper'
}, {
	code: '9',
	value: 'Others'
}]

export const YEAR_LEVEL = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Day Care'
}, {
	code: '2',
	value: 'Kindergarten / Preparatory'
}, {
	code: '11-16',
	value: 'Grade I to Grade VI'
}, {
	code: '17',
	value: 'Grade 7'
}, {
	code: '18',
	value: 'Grade 8'
}, {
	code: '19',
	value: 'Grade 9 / 3rd Year HS'
}, {
	code: '20',
	value: 'Grade 10 / 4th Year HS'
}, {
	code: '21',
	value: 'Grade 11'
}, {
	code: '22',
	value: 'Grade 12'
}, {
	code: '23-25',
	value: '1st Year to 3rd Post Secondary / TechVoc'
}, {
	code: '31-34',
	value: '1st Year to 4th Year (or Higher) College'
}, {
	code: '41',
	value: 'Post Grad w/ Units'
}]

export const EDUCATIONAL_ATTAINMENT = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Day Care'
}, {
	code: '2',
	value: 'Kindergarten / Preparatory'
}, {
	code: '11-16',
	value: 'Grade I to Grade VI'
}, {
	code: '17',
	value: 'Grade 7'
}, {
	code: '18',
	value: 'Grade 8'
}, {
	code: '19',
	value: 'Grade 9 / 3rd Year HS'
}, {
	code: '20',
	value: 'Grade 10 / 4th Year HS'
}, {
	code: '21',
	value: 'Grade 11'
}, {
	code: '22',
	value: 'Grade 12'
}, {
	code: '23-25',
	value: '1st Year to 3rd Post Secondary / TechVoc'
}, {
	code: '31-34',
	value: '1st Year to 4th Year (or Higher) College'
}, {
	code: '41',
	value: 'Post Grad w/ Units'
}, {
	code: '51',
	value: 'ALS Elementary'
}, {
	code: '52',
	value: 'ALS Secondary'
}, {
	code: '53',
	value: 'SPED Elementary'
}, {
	code: '54',
	value: 'SPED Secondary'
}, {
	code: '100',
	value: 'Grade School Graduate'
}, {
	code: '200',
	value: 'HS Graduate'
}, {
	code: '300',
	value: 'College Graduate'
}, {
	code: '400',
	value: 'Master\'s / PhD Graduate'
}]

export const DISABILITY_TYPE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Total Blindness'
}, {
	code: '2',
	value: 'Partial Blindness'
}, {
	code: '3',
	value: 'Low vision'
}, {
	code: '4',
	value: 'Totally deaf'
}, {
	code: '5',
	value: 'Partially deaf'
}, {
	code: '6',
	value: 'Oral defect'
}, {
	code: '7',
	value: 'One hand'
}, {
	code: '8',
	value: 'No hands'
}, {
	code: '9',
	value: 'One leg'
}, {
	code: '10',
	value: 'No legs'
}, {
	code: '11',
	value: 'Mild Cerebral Palsy'
}, {
	code: '12',
	value: 'Severe Cerebral Palsy'
}, {
	code: '13',
	value: 'Retarded'
}, {
	code: '14',
	value: 'Mentally Ill'
}, {
	code: '15',
	value: 'Mentally Retardation'
}, {
	code: '16',
	value: 'Multiply impairment'
}, {
	code: '17',
	value: 'Others, specify'
}]

export const OCCUPATION_CODE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Officials of Government and Special-Interest Organizations, Corporate Executives, Managers, Managing Proprietors and Supervisors'
}, {
	code: '2',
	value: 'Physical, Mathematical and Engineering Science Professionals'
}, {
	code: '3',
	value: 'Technicial and Associate Professionals'
}, {
	code: '4',
	value: 'Clerks'
}, {
	code: '5',
	value: 'Service Workers and Shop and Market Sales Workers'
}, {
	code: '6',
	value: 'Farmers, Forestry Workers and Fishermen'
}, {
	code: '7',
	value: 'Trades and Related Workers'
}, {
	code: '8',
	value: 'Plant and Machine Operators and Assemblers'
}, {
	code: '9',
	value: 'Laborers and Unskilled Workers'
}, {
	code: '10',
	value: 'Special Occupations'
}, {
	code: '11',
	value: 'Others (specify)'
}]

export const INDUSTRY_CODE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Agriculture mining and Forestry'
}, {
	code: '2',
	value: 'Fishing'
}, {
	code: '3',
	value: 'Mining and Quarrying'
}, {
	code: '4',
	value: 'Manufacturing'
}, {
	code: '5',
	value: 'Electricity, Gas and Water supply'
}, {
	code: '6',
	value: 'Construction'
}, {
	code: '7',
	value: 'Wholesale and Retail Trade, Vehicle Repair'
}, {
	code: '8',
	value: 'Hotel and Restaurants'
}, {
	code: '9',
	value: 'Transportation, Storage and Communication'
}, {
	code: '10',
	value: 'Financial Intermediation'
}, {
	code: '11',
	value: 'Real Estate, Renting and Business Activities'
}, {
	code: '12',
	value: 'Public Administration and Defense'
}, {
	code: '13',
	value: 'Education'
}, {
	code: '14',
	value: 'Health and Social Work'
}, {
	code: '15',
	value: 'Other community, Social or Personal Activities'
}, {
	code: '16',
	value: 'Private Households w/ Employed Persons'
}, {
	code: '17',
	value: 'Extra-territorial Organizations'
}]

export const CLASS_WORKER = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Worked for Household'
}, {
	code: '2',
	value: 'Worked for a private establishment'
}, {
	code: '3',
	value: 'Worked for government/government corporation'
}, {
	code: '4',
	value: 'Self employed without employees'
}, {
	code: '5',
	value: 'Employer in family-operated farm or business'
}, {
	code: '6',
	value: 'Worked with pay on own family farm or business'
}, {
	code: '7',
	value: 'Worked without pay on own family farm or business'
}]

export const NATURE_EMPLOYMENT = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Permanent'
}, {
	code: '2',
	value: 'Contractual'
}, {
	code: '3',
	value: 'Short-term, seasonal or casual'
}, {
	code: '3',
	value: '(Job Order) Worked on different jobs on day to day or week to week'
}]

export const CRIME_TYPE = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Murder / Homicide'
}, {
	code: '2',
	value: 'Theft'
}, {
	code: '3',
	value: 'Rape'
}, {
	code: '4',
	value: 'Physical Injury (not including battery)'
}, {
	code: '5',
	value: 'Trafficing / Illegal Recruitment'
}, {
	code: '6',
	value: 'Economic abuse'
}, {
	code: '7',
	value: 'Spousal / Partner abuse'
}, {
	code: '8',
	value: 'Sexual harrassment'
}, {
	code: '9',
	value: 'Child abuse'
}, {
	code: '10',
	value: 'Criminal'
}, {
	code: '11',
	value: 'Civil'
}, {
	code: '12',
	value: 'Other crimes (specify)'
}]

export const COMPLAIN_STATUS = [{
	code: 1,
	value: 'Sumbong (Complaint)'
}, {
	code: 2,
	value: 'Pabatid ng Pagdinig (Mediation Proceedings)'
}, {
	code: 3,
	value: 'Patawag (Summon)'
}, {
	code: 4,
	value: 'Pagdala ng Patawag (Issuance for Barangay Hearing)'
}, {
	code: 5,
	value: 'Minutes of Proceedings (Katitikan ng Pagdinig)'
}, {
	code: 6,
	value: 'Mapayapang Pagkakasundo (Amicable Settlement)'
}, {
	code: 7,
	value: 'Pabatid para sa pagbuo ng pangkat (Notice for Board Formation)'
}, {
	code: 8,
	value: 'Patalastas sa napiling bubuo ng pangkat (Notice to Selected Board Members respectively)'
}, {
	code: 9,
	value: 'Pabatid ng Pagdinig (Conciliation Proceedings)'
}, {
	code: 10,
	value: 'Subpoena (Patawag)'
}, {
	code: 11,
	value: 'Kasunduan sa Paghahatol (Agreement for Arbitration)'
}, {
	code: 12,
	value: 'Pinahatulang Gawad (Arbitration Award)'
}, {
	code: 13,
	value: 'Pagpapatunay ng hadlang sa ganting-kahilingan (Certification to Bar Counter Claim)'
}, {
	code: 14,
	value: 'Mungkahi ng Pagpapatupad (Motion for Execution)'
}, {
	code: 15,
	value: 'Patalastas ng Pagdinig'
}, {
	code: 16,
	value: 'Patalastas ng Pagpapatupad'
}, {
	code: 17,
	value: 'Certification to non-compliance of Settlement/Agreement'
}, {
	code: 18,
	value: 'Certification to File Action'
}, {
	code: 19,
	value: 'Pagsangguni (Referral)'
}]

export const REASON_NOT_APPLYING_JOB = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Believes no work available'
}, {
	code: '2',
	value: 'Await result of previous application'
}, {
	code: '3',
	value: 'Temporary Illness/Disability'
}, {
	code: '4',
	value: 'Bad weather'
}, {
	code: '5',
	value: 'Waiting for rehire'
}, {
	code: '6',
	value: 'Too young/ old, retired or permanently disabled'
}, {
	code: '7',
	value: 'Housekeeping'
}, {
	code: '8',
	value: 'Schooling'
}, {
	code: '9',
	value: 'Others (Actively seeking for work)'
}]

export const ILLNESSES = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Cancer'
}, {
	code: '2',
	value: 'Diabetes'
}, {
	code: '3',
	value: 'Hypertension'
}, {
	code: '4',
	value: 'Stroke'
}, {
	code: '5',
	value: 'Heart Failure'
}, {
	code: '6',
	value: 'Chronic Kidney Disease'
}, {
	code: '7',
	value: 'Other specify'
}]

export const RESPIRATORY_ISSUES = [{
	code: '0',
	value: 'Not applicable'
}, {
	code: '1',
	value: 'Asthma'
}, {
	code: '2',
	value: 'Pneumonia'
}, {
	code: '3',
	value: 'Tuberculosis'
}, {
	code: '4',
	value: 'COPD (Chronic Obstructive Pulmonary Disease)'
}, {
	code: '5',
	value: 'Other specify'
}]

export const RELIGION = [{
	code: '0',
	value: 'Iglesia ni Cristo (INC)'
}, {
	code: '1',
	value: 'Catholic'
}, {
	code: '2',
	value: 'Protestant'
}, {
	code: '3',
	value: 'Other specify'
}]